import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function NotFound() {
  return (
    <div className="min-h-[80vh] flex items-center justify-center bg-cream-100 px-6 py-24">
      <Helmet>
        <title>Siden blev ikke fundet | Dahliahjørnet</title>
        <meta name="description" content="Fejl 404 - Siden findes ikke." />
      </Helmet>
      <div className="max-w-md w-full text-center bg-white p-10 rounded-3xl shadow-md border border-cream-200 flex flex-col gap-6">
        <div className="w-20 h-20 rounded-full bg-dahlia-50 flex items-center justify-center text-dahlia-500 text-4xl mx-auto shadow-sm">
          <i className="fa-solid fa-compass-slash" />
        </div>
        <div className="flex flex-col gap-2">
          <h1 className="text-3xl font-serif font-bold text-forest-950">Siden blev ikke fundet</h1>
          <p className="text-xs font-bold uppercase tracking-widest text-dahlia-600">Fejl 404 - Not Found</p>
        </div>
        <p className="text-charcoal-600 text-sm leading-relaxed">
          Beklager, men den side du leder efter findes ikke eller er blevet flyttet. Brug venligst menuen eller knappen nedenfor til at finde vej.
        </p>
        <div className="flex flex-col gap-3 mt-2">
          <Link
            to="/"
            className="bg-forest-700 hover:bg-forest-800 text-white py-3 rounded-full font-semibold shadow-md transition-all flex items-center justify-center gap-2"
          >
            <i className="fa-solid fa-house" />
            Gå til forsiden
          </Link>
          <Link
            to="/kontakt"
            className="bg-cream-100 hover:bg-cream-200 text-forest-950 py-3 rounded-full font-semibold border border-cream-300 transition-all flex items-center justify-center gap-2"
          >
            <i className="fa-solid fa-envelope" />
            Kontakt os
          </Link>
        </div>
      </div>
    </div>
  );
}
